<div class="chart-empty" [ngClass]="{'chart-empty-mobile-flex': mobileFlex}">
  <img src="assets/icons/no_data.svg" alt="" class="chart-empty-icon" *ngIf="!white">
  <img src="assets/icons/no_data_white.svg" alt="" *ngIf="white">
  <span [ngClass]="{'white': white}">{{ msgText ? msgText : ('IP.DASHBOARD.GRAPHIC.NO_DATA'| translate)}}</span>
</div>